<template>
    <!-- Authors Table Card -->
    <a-card :bordered="false" class="header-solid h-full">
        <a-row :gutter="24" type="flex">
            <!-- Authors Table Column -->
            <a-col :span="24" class="mb-24">
                <a-form layout="inline" :form="dataForm" @submit="getDataList" class="ml-20">
                    <a-form-item>
                        <a-button type="primary" @click="getDataList" :loading="dataListLoading">搜索</a-button>
                    </a-form-item>
                    <a-form-item v-permission="['admin:account:create']">
                        <a-button type="primary" @click="addOrUpdateHandle()">新增数据</a-button>
                    </a-form-item>
                </a-form>

                <a-table :columns="columns" :data-source="dataList" :pagination="false"
                    rowKey="bannerid" :loading="dataListLoading">
                    <template slot="url" slot-scope="text, row">
                        <img :src="text" alt="" width="80px" height="80px" style="cursor: pointer" @click="preview(text)" />
                    </template>
                    <template slot="editBtn" slot-scope="text, row">
                        <a-button type="link" class="btn-edit" @click="addOrUpdateHandle(row.bannerid)">
                            编辑
                        </a-button>
                        <a-button type="link" class="btn-edit" @click="deleteHandle(row.bannerid)">
                            删除
                        </a-button>
                    </template>
                </a-table>
            </a-col>
            <!-- / Authors Table Column -->
        </a-row>

        <a-pagination class="mr-20 float-right" show-size-changer :current="page" :total="total"
            :show-total="(total) => `共 ${total} 条数据`" @showSizeChange="showSizeChange"
            @change="pageCurrentChangeHandle" />
        <addorupdate ref="addOrUpdate" @ok="getDataList"></addorupdate>
    </a-card>
    <!-- / Authors Table Card -->
</template>

<script>
import viewModule from "@/mixins/view-module";
import addorupdate from "./components/addorupdatebanner.vue";
export default {
    mixins: [viewModule],
    components: {
        addorupdate,
    },
    data() {
        return {
            mixinViewModuleOptions: {
                getDataListURL: "/admin/appbanner/page",
                deleteURL: "/admin/appbanner/delete",
            },
            dataForm: {
                title: "",
                type: undefined
            },
            columns: [
                {
                    title: "图片素材",
                    dataIndex: "url",
                    width: 400,
                    scopedSlots: { customRender: "url" },
                },
                {
                    title: "排序",
                    dataIndex: "sort",
                    width: 100
                },
                {
                    title: "",
                    scopedSlots: { customRender: "editBtn" },
                    width: 200,
                    fixed: "right",
                },
            ],
        };
    },
    methods: {
        preview(url) {
            this.$viewerApi({
                images: [url],
            });
        },
    },
};
</script>